(() => {
  const HANDLE = 'soft-no-pull-cat-harness-leash-set-comfortable-adjustable-walking-vest-for-cats-small-dogs';
  const ADDON_PRICE = 1999;
  let productPromise;
  let busy = false;
  let integrityObserver;

  const isHarness = () => location.pathname.toLowerCase().includes(`/products/${HANDLE}`);
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
  const getProduct = () => productPromise ||= fetch(`/products/${HANDLE}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(r => r.json());

  const ensureMobileGap = () => {
    if (!isHarness() || document.getElementById('HarnessSalePriceMobileGap')) return;
    const style = document.createElement('style');
    style.id = 'HarnessSalePriceMobileGap';
    style.textContent = `
      @media (max-width: 749px) {
        [data-powlife-product] [data-product-price][data-sale-product="true"] {
          column-gap: 20px !important;
        }
        [data-powlife-product] [data-product-price] [data-product-sale-price] {
          margin-left: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const render = async () => {
    if (!isHarness() || busy) return;
    ensureMobileGap();
    const root = document.querySelector('[data-powlife-product]') || document;
    const price = root.querySelector('[data-product-price]');
    const variantInput = root.querySelector('[data-variant-select]') || root.querySelector('[name="id"]');
    if (!price || !variantInput?.value) return;
    busy = true;
    try {
      const product = await getProduct();
      const variant = product?.variants?.find(v => Number(v.id) === Number(variantInput.value)) || product?.variants?.[0];
      if (!variant) return;
      const addon = root.querySelector('[data-addon-choice]');
      const extra = addon?.checked ? ADDON_PRICE : 0;
      const sale = Number(variant.price || 0) + extra;
      const compareBase = Number(variant.compare_at_price || 0);
      const compare = compareBase > Number(variant.price || 0) ? compareBase + extra : 0;

      let compareEl = price.querySelector('[data-product-compare-price]');
      let saleEl = price.querySelector('[data-product-sale-price]');
      if (!compareEl || !saleEl) {
        price.innerHTML = '<span class="pl-buy__compare-price" data-product-compare-price></span><span class="pl-buy__sale-price" data-product-sale-price></span>';
        compareEl = price.querySelector('[data-product-compare-price]');
        saleEl = price.querySelector('[data-product-sale-price]');
      }
      const compareText = compare ? money(compare) : '';
      const saleText = money(sale);
      if (compareEl.textContent !== compareText) compareEl.textContent = compareText;
      compareEl.hidden = !compare;
      if (saleEl.textContent !== saleText) saleEl.textContent = saleText;
    } finally {
      busy = false;
    }
  };

  const schedule = () => requestAnimationFrame(() => render().catch(() => {}));

  const watchPriceIntegrity = () => {
    if (!isHarness() || integrityObserver) return;
    const root = document.querySelector('[data-powlife-product]') || document;
    const price = root.querySelector('[data-product-price]');
    if (!price) return;
    integrityObserver = new MutationObserver(() => {
      if (!price.querySelector('[data-product-sale-price]') || !price.querySelector('[data-product-compare-price]')) {
        schedule();
      }
    });
    integrityObserver.observe(price, { childList: true, subtree: true });
  };

  const boot = () => {
    ensureMobileGap();
    watchPriceIntegrity();
    schedule();
    setTimeout(schedule, 80);
    setTimeout(schedule, 300);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('change', e => {
    if (e.target.matches?.('[data-addon-choice], [data-variant-select], [name="id"]')) {
      setTimeout(schedule, 0);
      setTimeout(schedule, 80);
    }
  });
  document.addEventListener('shopify:section:load', () => {
    integrityObserver?.disconnect();
    integrityObserver = undefined;
    boot();
  });
})();